import { render, staticRenderFns } from "./OgTableBody.vue?vue&type=template&id=789061a6&"
import script from "./OgTableBody.vue?vue&type=script&lang=js&"
export * from "./OgTableBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports